module.exports = __webpack_public_path__ + "static/media/why-us-image.807a1982.png";